import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function CalculatorPage() {
  return <AppPagePlaceholder name="Calculator" />;
}
